import * as signalR from "@microsoft/signalr";
import { actionTypes } from "app/modules/auth";
import { container } from "setup/dependency/inversify.config";
import { ISessionService } from "services/SessionService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { setAPIUnavailable } from "app/system/apiStatus/APIStatusSlice";
import { setupCommonSignalRFunctions } from "./Notifications/SignalRNotificationHelpers";

/* eslint @typescript-eslint/no-explicit-any: 0 */
let connection: signalR.HubConnection;
let initialised: boolean = false;
let reconnectIntervalID: ReturnType<typeof setInterval> | null = null;

const RECONNECT_INTERVAL = 1000 * 10; // 10 seconds

const startSignalRConnection = (dispatch: (arg0: any) => any, userID: string) => {
  if (initialised) {
    return connection
      .start()
      .then(() => {
        connection.invoke("Authenticate", userID).catch(() => {
          dispatch(setAPIUnavailable(true));
          reconnectIntervalID = setInterval(startSignalRConnection, RECONNECT_INTERVAL, dispatch, userID);
        });

        dispatch(setAPIUnavailable(false));
        if (reconnectIntervalID) {
          clearInterval(reconnectIntervalID);
        }
      })
      .catch(() => {
        dispatch(setAPIUnavailable(true));

        if (!reconnectIntervalID) {
          reconnectIntervalID = setInterval(startSignalRConnection, RECONNECT_INTERVAL, dispatch, userID);
        }
      });
  }
};

const cpl3SignalRMiddleware =
  ({ dispatch }: { dispatch: (arg0: any) => any }) =>
  (next: (arg0: { type: string }) => any) =>
  (action: { type: string; payload: any }) => {
    if (action.type === actionTypes.SetUser && !initialised) {
      const protocol = new signalR.JsonHubProtocol();
      const transport = signalR.HttpTransportType.LongPolling;

      const sessionService = container.get<ISessionService>(SERVICE_TYPES.SessionService);
      const options: signalR.IHttpConnectionOptions = {
        transport,
        logMessageContent: true,
        logger: signalR.LogLevel.Error,
        accessTokenFactory: async () => {
          return await sessionService.getCPLSessionToken();
        },
        headers: {
          Timeout: "-1",
        },
        withCredentials: false,
      };

      connection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_CPL_API_BASE_URI}/Notifications`, options)
        .withHubProtocol(protocol)
        .build();

      initialised = true;

      setupCommonSignalRFunctions(connection, dispatch);

      const clientPortalUserID = action.payload.user.clientPortalUserID;
      connection.onclose(() => startSignalRConnection(dispatch, clientPortalUserID));

      startSignalRConnection(dispatch, clientPortalUserID);
    }

    if (action.type === actionTypes.Logout && initialised) {
      initialised = false;
      if (reconnectIntervalID) {
        clearInterval(reconnectIntervalID);
      }
      connection.stop();
    }

    return next(action);
  };

export default cpl3SignalRMiddleware;
